var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickaxeSmallCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm2.75-6.646a.507.507 0 00-.12-.269L7.082 2.931a.614.614 0 00-.397-.181H4.312a.614.614 0 00-.396.181L2.869 4.085a.504.504 0 00-.119.259c1.355-.41 2.757-.71 2.757-.71s1.397.324 2.743.72zM5.2 8.25V4.651c0-.188-.139-.327-.309-.31 0 0-.953.092-2.141.267.014.046.035.09.062.13L5.199 8.25zm2.983-3.513a.477.477 0 00.06-.127c-1.183-.175-2.14-.268-2.14-.268-.17-.018-.308.12-.308.308V8.25l2.388-3.512z",
    fill: "#38474D",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickaxeSmallCircle);
export default __webpack_public_path__ + "static/media/pickaxe_small_circle.9afe16f057d9752af02cd271e935f90f.svg";
export { ForwardRef as ReactComponent };